import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function VerifySuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      // 🔥 SAVE TOKEN (LOGIN USER)  // 
      localStorage.setItem("token", token);

      // 🔥 REDIRECT TO DASHBOARD
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [navigate]);

  return <h2>Verifying your account...</h2>;
}